import { Typography } from 'antd';
import TransactionIcon from '../TransactionIcon';
import { formatToINR } from '../../../../Utils/utils';
import dayjs from 'dayjs';
import { ReactComponent as IncomingTxn } from '../../../../Assets/incomingTxn.svg';
import { ReactComponent as OutgoingTxn } from '../../../../Assets/outgoingTxn.svg';
import styles from './index-other.module.css';
import { useContext } from 'react';
import { AppContext } from '../../../../App';
import { getTenant } from '../../../../Utils/storageUtils';
import { TenantType } from '../../../../Utils/types';

const TransactionCardOld: React.FC<{
  transaction: any;
  iconSize?: any;
  transactionImageBGProp?: any;
  showDateOfTransaction?: boolean;
  isPendingRec?: boolean;
  isCompletedRec?: boolean;
}> = ({
  transaction,
  iconSize,
  transactionImageBGProp,
  showDateOfTransaction,
  isCompletedRec,
  isPendingRec,
}) => {
  const { isAmountVisible }: any = useContext(AppContext);

  let merchantName;
  if (transaction && transaction.displayName) {
    merchantName = transaction.displayName.split('-');
  } else if (transaction && transaction.category) {
    merchantName = transaction.category.split('-');
  } else if (transaction && transaction.narration) {
    merchantName = transaction.narration.split('-');
  }

  return (
    <>
      <TransactionIcon
        category={transaction.category}
        categoryCode={transaction.categoryCode}
        iconSize={iconSize}
        merchantLogoCode={transaction.merchantLogoCode}
        transactionImageBGProp={transactionImageBGProp}
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
          flexGrow: 1,
          minWidth: 0,
          marginLeft: 8,
          gap: 2,
        }}
      >
        <Typography.Text
          style={{
            fontWeight: 500,
            marginRight: 'auto',
            textOverflow: 'ellipsis',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            flexGrow: 1,
            width: '97%',
            color: '#373A3E',
          }}
        >
          {merchantName && merchantName.length >= 2
            ? merchantName[1]
            : merchantName[0]}
        </Typography.Text>

        {transaction.id ? (
          <Typography.Text
            style={{
              color: '#8F9194',
              fontSize: '10px',
              fontWeight: 500,
              marginRight: 'auto',
              lineHeight: '16px',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              flexGrow: 1,
              width: '97%',
            }}
          >
            {merchantName && merchantName.length > 1
              ? merchantName[0]
              : 'Others'}
          </Typography.Text>
        ) : (
          <></>
        )}
      </div>

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          flex: '25%',
          justifyContent: 'flex-end',
          gap: 6,
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-end',
          }}
        >
          <Typography.Text
            className={
              transaction && transaction.type
                ? transaction.type.toLowerCase().startsWith('c')
                  ? styles.creditArrow
                  : transaction.type.toLowerCase().startsWith('d')
                  ? styles.debitArrow
                  : ''
                : transaction && transaction.format
                ? styles.debitArrow
                : styles.debitArrow
            }
            style={{
              wordBreak: 'keep-all',
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              fontWeight: 400,
            }}
          >
            {transaction && (transaction.amount || transaction.format)
              ? transaction.format
                ? `${formatToINR(
                    transaction.lastAmount,
                    getTenant() === TenantType.PB ? true : isAmountVisible
                  )}`
                : `${formatToINR(
                    transaction.amount.toString(),
                    getTenant() === TenantType.PB ? true : isAmountVisible
                  )}`
              : ''}
          </Typography.Text>

          {showDateOfTransaction ? (
            <Typography.Text className={styles.dateRecurringTxn}>
              {dayjs(
                transaction.dateOfTransaction
                  ? transaction.dateOfTransaction
                  : isCompletedRec
                  ? transaction.lastTransactionDate
                  : isPendingRec
                  ? transaction.upcomingDate
                  : transaction.dateOfTransaction
              ).format("on D MMM'YY")}
            </Typography.Text>
          ) : (
            <></>
          )}
        </div>
        {transaction && transaction.type ? (
          transaction.type.toLowerCase().startsWith('c') ? (
            <IncomingTxn />
          ) : transaction.type.toLowerCase().startsWith('d') ? (
            <OutgoingTxn />
          ) : (
            <></>
          )
        ) : (
          ''
        )}
      </div>
    </>
  );
};

export default TransactionCardOld;
